export const ctaBannersQueryKeys = {
  _base: () => ["ctaBanners"],
  all: (agencyId: string) => [...ctaBannersQueryKeys._base(), { agencyId }],
};
